"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const AboutTheRegulationsIcon = createIcon({
  displayName: "AboutTheRegulationsIcon",
  viewBox: "0 0 42 45",
  path: (
    <>
      <path
        d="M0,45v-4.74h28v4.74H0ZM13.18,33.51L0,20.13l4.9-5.09,13.3,13.38-5.02,5.09ZM28,18.47L14.82,4.97,19.83,0l13.18,13.38-5.02,5.09ZM38.73,42.63L8.28,11.72l3.27-3.32,30.45,30.91-3.27,3.32Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default AboutTheRegulationsIcon;
